/**
 * @typedef {Object} HomeCarouselSlide
 * @property {string|number} [id] - Payload document id
 * @property {string} key
 * @property {string} title
 * @property {string} [text]
 * @property {string} [image] - CDN-relative path
 * @property {string} url - Internal path (localized)
 * @property {'left'|undefined} [position]
 * @property {string} [publish_at]
 * @property {string} [unpublish_at]
 */

/**
 * Maps a Payload `home-carousel` document to the legacy ERS slide shape
 * consumed by MoreThanShows and shouldPublish().
 *
 * @param {Record<string, unknown>} doc - Payload REST document
 * @param {string} [_locale]
 * @returns {HomeCarouselSlide}
 */
export function mapHomeCarouselSlide(doc, _locale) {
  return {
    id: doc.id != null ? doc.id : undefined,
    key: doc.key,
    title: doc.title,
    text: doc.text || undefined,
    image: doc.image || undefined,
    url: doc.url,
    position: doc.position === "left" ? "left" : undefined,
    publish_at: doc.publishAt || undefined,
    unpublish_at: doc.unpublishAt || undefined,
  };
}

/**
 * @param {{ docs?: unknown[] }} payloadResponse
 * @param {string} [locale]
 * @returns {HomeCarouselSlide[]}
 */
export function mapHomeCarouselResponse(payloadResponse, locale) {
  const docs = Array.isArray(payloadResponse?.docs) ? payloadResponse.docs : [];
  return docs.map((doc) => mapHomeCarouselSlide(doc, locale));
}
